export default __webpack_public_path__ + "c4df6d86db7daea86c43de3df5d4baba.svg";